import React from 'react'
import { Link } from 'gatsby'

import Layout from '../components/layout'
// import Image from "../components/image"
import SEO from '../components/seo'
// import SlideCarousel from "../components/slideCarousel";
import HomeJumbotron from '../components/homeJumbotron'
// import CompanyLinks from "../components/companyLinks";
// import ImagesStrip from "../components/ImagesStrip";

import Retail from '../images/Cheltenhamcen.jpg'
import Leisure from '../images/dartford/drt5 - Copy.jpg'

// import { FaRegGem } from "react-icons/fa";
// import { FaRegClock } from "react-icons/fa";
// import { FaPiggyBank } from "react-icons/fa";
// import { FaHardHat } from "react-icons/fa";
// import { FaCheckCircle } from "react-icons/fa";

const IndexPage = () => (
  <Layout>
    <SEO title='Home' keywords={[`gatsby`, `application`, `react`]} />
    <div className='container'>
      <HomeJumbotron />
      <div className='row'>
        <div className='col-sm d-flex justify-content-center'>
          <Link className='' to='/retail'>
            <img src={Retail} alt='Retail' style={{ width: '100%' }} />
            <h1 className='centered text-light display-4 dark-overlay px-3 pb-2'>
              Retail
            </h1>
          </Link>
        </div>
        <div className='col-sm d-flex justify-content-center'>
          <Link className='' to='/leisure'>
            <img src={Leisure} alt='Leisure' style={{ width: '100%' }} />
            <h1 className='centered text-light display-4 dark-overlay px-3 pb-2'>
              Leisure
            </h1>
          </Link>
        </div>
      </div>
    </div>
    {/* <h1 className="text-center mb-3 p-3 display-4">Welcome to our site</h1> */}

    {/* <CompanyLinksBox /> */}

    {/* <ImagesStrip /> */}

    {/* <div className="container-fluid p-2 pt-3 mb-3 border border-dark">
        <h1 className="d-block text-center display-4 mb-3">
          We deliver our projects:
        </h1>
        <ul className="list-unstyled text-center">
          <li style={{ fontSize: "1.2em" }}>
            <FaRegClock id="icon" />
            <p className="">On Time</p>
          </li>
          <li style={{ fontSize: "1.2em" }}>
            <FaPiggyBank id="icon" />
            <p className="">On Budget</p>
          </li>
          <li style={{ fontSize: "1.2em" }}>
            <FaHardHat id="icon" />
            <p className="">Safe</p>
          </li>
          <li style={{ fontSize: "1.2em" }}>
            <FaCheckCircle id="icon" />
            <p className="">Hassle Free</p>
          </li>
          <li style={{ fontSize: "1.2em" }}>
            <FaRegGem id="icon" />
            <p className="">To the High Quality you expect</p>
          </li>
        </ul>
      </div>
      <div className="row justify-content-center my-5">
        <div className="">
          <SlideCarousel />
        </div>
      </div>
      <div className="d-block text-center">
        <h4 className="display-4">Find out more</h4>
      </div>
      <hr className="my-2" />
      <div className="row d-flex justify-content-around mb-5">
        <Link
          className="btn btn-outline-dark btn-lg mb-2"
          to="/services"
          style={{ minWidth: "175px" }}
        >
          Our Services
        </Link>
        <Link
          className="btn btn-outline-dark btn-lg mb-2"
          to="/projects"
          style={{ minWidth: "175px" }}
        >
          Recent Projects
        </Link>
        <Link
          className="btn btn-outline-dark btn-lg mb-2"
          to="/retail"
          style={{ minWidth: "175px" }}
        >
          Retail Services
        </Link>
        <Link
          className="btn btn-outline-dark btn-lg mb-2"
          to="/leisure"
          style={{ minWidth: "175px" }}
        >
          Leisure Services
        </Link>
      </div> */}

    {/* <CompanyLinks /> */}

    {/* <Link to="/page-2/">Go to page 2</Link> */}
  </Layout>
)

export default IndexPage
